import React, { useContext, useEffect } from 'react';
import { UIContext } from 'context/ui';

interface IProps {
  children: React.ReactNode;
  pathname: string;
}

export const LocationWrapper = ({ children, pathname }: IProps) => {

  const { setHomepage } = useContext(UIContext);

  useEffect(() => {
    setHomepage(pathname === '/');
    // setSearch(pathname.includes('/search/'));

  }, [pathname]);

  return <>{children}</>;
};
